import Rete from 'rete';

import { distSocket } from './index';

import samplingNumber from '../../util/density/samplingNumber';
import timeSlices from '../../util/density/timeSlices';

import NumControl from './NumControl';


import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';


export default class NumComponent extends Rete.Component {

	constructor(){
		super("Number");
		this.path = [];
		this.contextMenuName = "Number";
	}

	builder(node) {
		let out1 = new Rete.Output('number', "Output", distSocket);	

		return node.addControl(new NumControl(this.editor, 'value')).addOutput(out1);
	}

	destroyed(node){

		// console.log(`Node ${node.id} was destroyed.`)

		// Remove all event listeners -- otherwise they will respond even if node does no longer exist

	}

	worker(node, inputs, outputs) {

		// Get all predecessors
		let predecessors = [];

		// Iterate over sockets, and inputs to collect all predecessors (their UUIDs)
		for (let [socket, inputArray] of Object.entries(inputs)) {
			for (let i = 0; i < inputArray.length; i++){
				if (inputArray[i]){
					predecessors.push(inputArray[i]['predecessor']);
				} else {
					console.log('A predecessor could not be determined. Likely because an embedded module is currently open. Any tree view will then be incomplete.')
				}
			}
		}

		let matrix = [];
		let timeSliceValue = timeSlices();
		let samplingValue = samplingNumber();

		for (let i = 0; i < timeSliceValue; i++) {
			let array = [];
			for (let j = 0; j < samplingValue; j++) {
				array.push(node.data.value);
			}
			matrix.push(array);
		}

		// console.log(matrix)

		// NEW
		// Generate a new UUID for this node instance(!)
		const nodeUUID = uuidv4();

		// Nota bene: for this component, the output socket is called 'number' (not 'dist')
		outputs['number'] = {
			predecessor: nodeUUID,
			data: matrix,
		};

		let hasPredecessors = predecessors.length > 0 ? true : false;

		// Write global node data object
		Vue.prototype.$globalSharedData.globalNodeData[nodeUUID] = {
			hasPredecessors: hasPredecessors,
			predecessors: [],
			nodeID: node.id,
			data: matrix,
			name: node.data.title,
			nodeFunction: node.name,
			module: undefined,
			nodeData: node.data,
		}

	}
}
